import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  bar: {
    backgroundColor: '#FFF',
    borderLeft: 'solid 1px #dfdfe6',
    width: 55,
    margin: 0,
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    paddingTop: 20,
    position: 'relative'
  },
  colorPrimary: {
    backgroundColor: '#30b0ff'
  },
  iconsBoxActive: {
    backgroundColor: '#edf4ff',
    padding: 5,
    borderRadius: 6,
    marginBottom: 10,
    cursor: 'pointer'
  },
  iconsBox: {
    padding: 5,
    marginBottom: 10,
    cursor: 'pointer'
  },
}));

export default useStyles;
